import { commonAPI } from '@/services-ts/axios'
import type { IGetHekateHistory, IPayloadHekate } from '@/types/Request'
import type { IHekateStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useHekateStore = defineStore('hekate', {
  state: (): IHekateStore => ({
    gdprList: [],
    gdprContentList: [],
    history: [],
  }),

  actions: {
    async GetGdprList() {
      const { status, data } = await commonAPI.HekateServices.GetGdprList()
      this.gdprList = status ? data : []
    },

    async CreateGdpr(data: IPayloadHekate) {
      const { status } = await commonAPI.HekateServices.CreateGdpr(data)

      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
        await this.GetGdprList()
      }
      return status
    },

    async UpdateGdpr(payload: IPayloadHekate) {
      if (!payload.Id) return false
      const { status } = await commonAPI.HekateServices.UpdateGdpr(payload, payload.Id)

      if (status) {
        void Alert({ message: Format('admin_global_success'), type: 'success' })
        await this.GetGdprList()
      }
      return status
    },

    async DeleteGdpr(RootId: string) {
      const { status } = await commonAPI.HekateServices.DeleteGdpr(RootId)

      if (status) {
        this.gdprList = this.gdprList.filter(x => x.id !== RootId)
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
    },

    async GetGdprContentList(RootId: string) {
      const { status, data } = await commonAPI.HekateServices.GetGdprContentList(RootId)

      this.gdprContentList = status ? data : []
    },

    async GetGdprHistory(payload: IGetHekateHistory) {
      const { status, data } = await commonAPI.HekateServices.GetGdprHistory(payload)
      this.history = status ? data : []
    },
  },
})
